/**
 * @flow
 * @relayHash f8cb83316ffc992775cc28665ae775e6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ExpenseTypeWhere = {|
  and?: ?$ReadOnlyArray<?ExpenseTypeWhere>,
  or?: ?$ReadOnlyArray<?ExpenseTypeWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  accountId?: ?ConditionInputType,
  description?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  forVehicles?: ?ConditionInputType,
  isRestricted?: ?ConditionInputType,
  requiredPermission?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type ExpenseTypeSelectQueryVariables = {|
  where?: ?ExpenseTypeWhere
|};
export type ExpenseTypeSelectQueryResponse = {|
  +expenseTypes: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +forVehicles: ?boolean,
        +isRestricted: ?boolean,
        +requiredPermission: ?string,
      |}
    |}>
  |}
|};
export type ExpenseTypeSelectQuery = {|
  variables: ExpenseTypeSelectQueryVariables,
  response: ExpenseTypeSelectQueryResponse,
|};
*/


/*
query ExpenseTypeSelectQuery(
  $where: ExpenseTypeWhere
) {
  expenseTypes(where: $where, orderBy: [code], order: ASC) {
    edges {
      node {
        id
        name
        forVehicles
        isRestricted
        requiredPermission
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "ExpenseTypeWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "expenseTypes",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "code"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "ExpenseTypeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ExpenseTypeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ExpenseType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "forVehicles",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isRestricted",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "requiredPermission",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ExpenseTypeSelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ExpenseTypeSelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ExpenseTypeSelectQuery",
    "id": null,
    "text": "query ExpenseTypeSelectQuery(\n  $where: ExpenseTypeWhere\n) {\n  expenseTypes(where: $where, orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        name\n        forVehicles\n        isRestricted\n        requiredPermission\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '15b42e597ddf63ca9535b1c343a0cf96';
module.exports = node;
